import { z } from "zod"

/**
 * Replaces raw JSON fields in widget configuration by parsed Zod schemas.
 * We could probably do with less "any"s, but it seems complicated and needs a lot of kong fu typing...
 */
export function parseJsonFields<Result extends {
  _parsingErrors: Error[]
}>(
  rawConfig: Record<string, any>,
  schemas: Record<string, z.ZodTypeAny>
): Result {
  const rest = { ...rawConfig }
  const parsed: Record<string, any> = {}
  const errors: Error[] = []

  for (const key in schemas) {
    const schema = schemas[key]!
    const value = rawConfig[key]
    delete rest[key]

    let parsedValue: any = null

    if (!value) continue

    try {
      const parsedJson = JSON.parse(value)
      const result = schema.safeParse(parsedJson)
      if (result.success) {
        parsedValue = result.data
      } else {
        errors.push(result.error)
        console.error(`Invalid schema for field "${key}"`, result.error)
      }
    } catch (err) {
      if (err instanceof Error) errors.push(err)
      else errors.push(new Error(String(err)))
      console.error(`Failed to parse JSON for field "${key}"`, err)
    }

    parsed[key] = parsedValue
  }

  return {
    ...rest,
    ...parsed,
    _parsingErrors: errors
  } as Result
}
